import { useState } from 'react';
import { useAgent } from 'agents/react';
import type { InterviewSessionState } from '@shared/index';
import { API_BASE_URL } from '@/lib/api';

export function useInterviewAgent(
 sessionId: string,
 options?: { onMessage?: (event: MessageEvent) => void }
) {
 const [state, setSyncState] = useState<InterviewSessionState | null>(null);

 // The agent name matches the Durable Object class name on the backend
 // The instance name (room) is the unique sessionId
 const agent = useAgent<InterviewSessionState>({
  agent: 'InterviewSession',
  name: sessionId,
  host: API_BASE_URL.replace(/^https?:\/\//, ''),
  onStateUpdate: (newState) => {
   setSyncState(newState);
  },
  onMessage: options?.onMessage,
 });

 return { agent, state };
}
